import React from 'react';
import {DataUsageContainer, DataUsageFill} from './styled';
import {useTranslation} from 'react-i18next';
import {Layout, Text} from '@phonectas/unifon-ui-kit';
import {formatInfo} from 'utils/div';
import {convertMB} from 'utils/file';

interface DataUsageProps {
	totalData: number | null;
	usedData: number | null;
	compact?: boolean;
}

const DataUsage: React.FC<DataUsageProps> = ({totalData, usedData, compact = false}) => {
	const [t] = useTranslation();
	// if (totalData === null && usedData === null) return 'N/A';
	const dataLimit = convertMB(totalData);
	const convertedUsedData = convertMB(usedData);
	const dataUsedPercentage = dataLimit.valueInMB ? (convertedUsedData.valueInMB / dataLimit.valueInMB) * 100 : 0;
	const fillColor = dataUsedPercentage > 100 ? '#EB5757' : 'rgba(135, 141, 230, 1)';
	const displayUsedData = convertedUsedData.valueInString ? convertedUsedData.valueInString : 'N/A';
	const displayDataLimit = dataLimit.valueInString ? dataLimit.valueInString : 'N/A';

	return (
		<Layout gap={compact ? 'none' : 'md'} style={{flexDirection: compact ? 'column' : undefined}} fullWidth nowrap>
			<Layout fullWidth nowrap style={{maxWidth: '120px'}}>
				<Text variant={compact ? 'body' : 'body1'} color="textSecondary">
					{ t('Data usage')}
				</Text>
			</Layout>
			<Layout fullWidth nowrap>
				{
					usedData !== null ? (
						<>
							{
								!compact ? (
									<>
										<Text variant="body1">
											{
												convertedUsedData?.valueInString && dataLimit?.valueInString ?
													`${convertedUsedData.valueInString} / ${dataLimit.valueInString}` :
													convertedUsedData?.valueInString ?
														convertedUsedData.valueInString :
														dataLimit?.valueInString ?
															dataLimit.valueInString :
															'n/a'
											}
										</Text>
										{
											!dataLimit || !convertedUsedData ? null : (
												<DataUsageContainer>
													<DataUsageFill
														style={{
															width: `${dataUsedPercentage}%`,
															backgroundColor: fillColor,
														}}
													/>
												</DataUsageContainer>
											)
										}
									</>
								) : (
									<Layout alignItems="center" nowrap>
										<Text>
											{
												convertedUsedData?.valueInString && dataLimit?.valueInString ?
													`${displayUsedData}/${displayDataLimit}` :
													convertedUsedData?.valueInString ?
														displayUsedData :
														dataLimit?.valueInString ?
															displayDataLimit :
															'n/a'
											}
										</Text>
										{
											!dataLimit || !convertedUsedData ? null : (
												<DataUsageContainer>
													<DataUsageFill
														style={{
															width: `${dataUsedPercentage}%`,
															backgroundColor: fillColor,
														}}
													/>
												</DataUsageContainer>
											)
										}
									</Layout>
								)
							}
						</>
					): (
						<>
							<Text variant={compact ? 'body' : 'body1'}>
								{formatInfo(usedData)}
							</Text>
						</>
					)
				}
			</Layout>
		</Layout>
	);
};

export default DataUsage;
